export default "__VITE_ASSET__Coi46TR7__"